// components/audit/ui.jsx — small shared building blocks for the Audit screens.
import { T, alpha } from '../../theme/theme'
import Icon from '../Icon'

export const inputStyle = {
  width: '100%', marginTop: '4px', padding: '9px 10px', background: T.s3, border: `1px solid ${T.bd}`,
  borderRadius: '8px', color: T.tx, fontSize: '13px', boxSizing: 'border-box', fontFamily: "'Outfit',sans-serif",
}

export const btn = (primary, disabled = false) => ({
  padding: '9px 16px', borderRadius: '8px', fontSize: '13px', fontWeight: 700,
  cursor: disabled ? 'not-allowed' : 'pointer', fontFamily: "'Outfit',sans-serif",
  border: primary ? 'none' : `1px solid ${T.bd}`,
  background: primary ? (disabled ? T.mt : T.prg) : 'transparent',
  color: primary ? T.onpri : T.mt, opacity: disabled ? 0.8 : 1,
})

export function Card({ title, subtitle, children, right, testId, style }) {
  return (
    <section data-testid={testId} style={{ background: T.s1, border: `1px solid ${T.bd}`, borderRadius: '12px',
      padding: '20px', marginBottom: '18px', ...style }}>
      {(title || right) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px',
          marginBottom: subtitle || children ? '12px' : 0, flexWrap: 'wrap' }}>
          <div>
            {title && <h2 style={{ margin: 0, fontFamily: "'Syne',sans-serif", fontSize: '16px', fontWeight: 800, color: T.tx }}>{title}</h2>}
            {subtitle && <div style={{ fontSize: '13px', color: T.mt, marginTop: '4px', maxWidth: '720px' }}>{subtitle}</div>}
          </div>
          {right}
        </div>
      )}
      {children}
    </section>
  )
}

export function Field({ label, hint, children }) {
  return (
    <label style={{ display: 'block', fontSize: '12px', fontWeight: 700, color: T.lt }}>
      {label}
      {children}
      {hint && <span style={{ display: 'block', fontSize: '11px', fontWeight: 400, color: T.mt, marginTop: '3px' }}>{hint}</span>}
    </label>
  )
}

const TONES = {
  ok: [T.gn, T.gnd], warn: [T.am, T.amd], bad: [T.rd, T.rdd], info: [T.bl, T.bld], muted: [T.mt, alpha(T.mt, 0.12)],
}
export function Pill({ tone = 'muted', children, testId }) {
  const [c, bg] = TONES[tone] || TONES.muted
  return (
    <span data-testid={testId} style={{ fontSize: '11px', fontWeight: 800, padding: '3px 9px', borderRadius: '999px',
      color: c, background: bg, whiteSpace: 'nowrap' }}>{children}</span>
  )
}

export function Notice({ tone = 'info', children, testId, role }) {
  const [c, bg] = TONES[tone] || TONES.info
  return (
    <div data-testid={testId} role={role || (tone === 'bad' ? 'alert' : 'status')}
      style={{ background: bg, border: `1px solid ${c}`, borderRadius: '10px', padding: '10px 14px', fontSize: '13px',
        color: T.tx, marginBottom: '12px', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
      <Icon name={tone === 'bad' ? 'block' : tone === 'warn' ? 'alert' : tone === 'ok' ? 'checkCircle' : 'info'}
        style={{ color: c, marginTop: '2px' }} />
      <div style={{ flex: 1 }}>{children}</div>
    </div>
  )
}

export function Spinline({ text = 'Loading…' }) {
  return <div style={{ color: T.mt, fontSize: '13px', padding: '8px 0' }}>{text}</div>
}

export const toneForStatus = (s) =>
  ({ attested: 'ok', withdrawn: 'muted', revoked: 'bad',
     open: 'info', report_issued: 'ok', file_assembled: 'ok' }[s] || 'muted')
